import { QueueRule } from '../models/queueRule';
import { queueRuleSchema } from '../models/queueRule.schema';
import { ruleCreatePayloadSchema } from './create.schema';

export type RuleCreatePayload = Omit<QueueRule, 'id' | 'url'>;

export const create = (payload: RuleCreatePayload) => {
  return {
    endpoint: `/rules`,
    method: 'POST',
    responseSchema: queueRuleSchema,
    payloadSchema: ruleCreatePayloadSchema,
    payload,
  } as const;
};
